export const NUMBER_OF_DEPENDENTS = {
  MIN: 0,
  MAX: 3,
};
